<template>
  <div class="header-box">
    <div class="header-box__list">
        <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeaderBox'
  }
</script>
